module.exports = ['settings', 'sentry', (settings, sentry) => {
  let service = {};
  const Transactions = new Map();
  const Spans = new Map();

  const fetch = window.fetch;
  window.fetch = (...args) => (async (args) => {// eslint-disable-line

    const spanArray = [...Transactions.values()].map(t => t.startChild(
      { op: 'http', description: args[0] }
    ));

    let result = await fetch(...args);
    if (spanArray.length > 0) {
      spanArray.forEach(span => {
        span.setTag('http.status_code', result.status);
        span.finish();
      });
    }
    return result;
  })(args);

  service.startLog = (eventName, searchData) => {
    if (!settings.logging.sentry.enabled) {
      return;
    }
    console.time(eventName);
    Transactions.set(eventName, sentry.startTransaction({ name: eventName, data: searchData }));
  };

  service.startSpan = (eventName, spanName, spanData) => { // eslint-disable-line
    const trans = Transactions.get(eventName);
    if (trans) {
      const span = trans.startChild(spanData);
      Spans.set(spanName, span);
      return span;
    }
  };

  service.endSpan = (spanName) => {
    const span = Spans.get(spanName);
    if (span) {
      span.finish();
      Spans.delete(spanName);
    }
  };

  service.endLog = (eventName) => {
    if (!settings.logging.sentry.enabled) {
      return;
    }
    const transaction = Transactions.get(eventName);
    if (transaction) {
      console.timeEnd(eventName);
      transaction.finish();
      Transactions.delete(eventName);
    }
  };

  return service;
}];
